import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { SysAdminAPIDto, SysAdminAPIsResponse } from '../types';

class SysAdmin {

  constructor() {
    makeAutoObservable(this);
  }

  allRequests: SysAdminAPIDto[] = [];

  getSysAdminAPIs = async () => {
    const sysAdminApiResponse: SysAdminAPIsResponse = await apiConfig.sysAdminPanelService.getAvailableAPIs();
    this.allRequests = sysAdminApiResponse.allRequests;
  };

}


export const SysAdminStore = new SysAdmin();